/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * Reconciliation (Totsugo) integration status of a received invoice. "unset" (未設定) is the default and is also reported for invoices that have no reconciliation record yet.

 */
export type ReceivedInvoiceReconciliationStatus =
  (typeof ReceivedInvoiceReconciliationStatus)[keyof typeof ReceivedInvoiceReconciliationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceivedInvoiceReconciliationStatus = {
  unset: 'unset',
  excluded: 'excluded',
  waiting: 'waiting',
  sent: 'sent',
} as const;
